import { render, staticRenderFns } from "./ClipboardOneLogin.vue?vue&type=template&id=189c92f3&scoped=true&"
import script from "./ClipboardOneLogin.vue?vue&type=script&lang=js&"
export * from "./ClipboardOneLogin.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardOneLogin.vue?vue&type=style&index=0&id=189c92f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c92f3",
  null
  
)

export default component.exports